import styled from 'styled-components';

const AccountBodyContainer = styled.div<React.CSSProperties>`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export default AccountBodyContainer;
